import { Container, Title, Text, Box } from "@mantine/core";

export default function CompliancePage() {
  return (
    <Box py={60} bg="white" style={{ minHeight: "60vh" }}>
      <Container size="md">
        <Title order={1} mb="md" c="primary.6">
          Compliance
        </Title>
        <Text c="slate.6">Content coming soon.</Text>
      </Container>
    </Box>
  );
}
